import type {Thread} from '@github-ui/diff-lines/conversation-types'

export function threadLabel(thread: Thread) {
  const path = thread.positioning?.path || thread.path || 'file'
  const {startLine, endLine: line} = thread.positioning ??
    thread.subject ?? {startLine: thread.startLine, endLine: thread.line}
  if (!line) return path
  return startLine && startLine !== line ? `${path}, lines ${startLine} to ${line}` : `${path}, line ${line}`
}
